// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"23ea0c22","291":"f3dd9e9d","385":"3c07f205","608":"b65ae2ca","661":"bdf42ecc","685":"f07a4a1c","721":"aaf72a69","732":"496e30e9","808":"b29efed2","821":"8beba2e3","846":"45c78fb1","856":"d6443a68","977":"e6ea726a"}[chunkId] + ".chunk.js";
};